import moment from 'moment';
import { useSelector } from 'react-redux';
import { getSelectorBasedStoreValue } from 'v2/modules/withRunForm/redux/selector';

export const useSelectState = () => {
  const calendarStartDate = useSelector((state) => getSelectorBasedStoreValue(state, 'calendarStartDate'));
  const calendarEndDate = useSelector((state) => getSelectorBasedStoreValue(state, 'calendarEndDate'));
  const reduxStart = useSelector((state) => getSelectorBasedStoreValue(state, 'startDate'));
  const reduxEnd = useSelector((state) => getSelectorBasedStoreValue(state, 'endDate'));
  const pipeConfigs = useSelector((state) => getSelectorBasedStoreValue(state, 'quantConfig.pipeConfigs'));
  const cases = useSelector((state) => getSelectorBasedStoreValue(state, 'quantConfig.cases'));
  const instrumentGroups = useSelector((state) =>
    getSelectorBasedStoreValue(state, 'quantConfig.instrumentGroups')
  );
  const runType = useSelector((state) => getSelectorBasedStoreValue(state, 'runType'));

  return {
    calendarStartDate: moment(calendarStartDate).toDate(),
    calendarEndDate: moment(calendarEndDate).toDate(),
    reduxStart: reduxStart,
    reduxEnd: reduxEnd,
    pipeConfigs,
    cases,
    instrumentGroups,
    runType,
  };
};
